var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatasetFormEditor',{attrs:{"form-name":"modifyDatasetForm","modification":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }